import type { UserIdentifiersFragment } from '@/js/libs/use-auth';

import type { Option } from 'src/types.ts';

// Names the user by the full name with the email, or by the email alone for a user without a name.
export const formatUserLabel = ({ email, firstName, lastName }: UserIdentifiersFragment): string => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  return fullName ? `${fullName} (${email})` : email;
};

// Identifies a user option by the email, so the select marks the impersonated user among the loaded options.
export const getUserOptionValue = ({ value }: Option<UserIdentifiersFragment>): string => value.email;
